import request from "@/util/http";
import qs from "qs";
export function sysDatasourceQuerySave(obj) {
  return request({
    url: "/admin/sysDatasourceQuery/save",
    method: "post",
    data: obj
  });
}
export function sysDatasourceQueryList(params) {
  return request({
    url: "/admin/sysDatasourceQuery/list",
    method: "get",
    params: params
  });
}
export function sysDatasourceQueryId(id) {
  return request({
    url: "/admin/sysDatasourceQuery/" + id,
    method: "get"
  });
}
export function sysDatasourceQuerySearchList(data) {
  return request({
    url: "/admin/sysDatasourceQuery/searchList",
    method: "post",
    data: data
  });
}
export function sysDatasourceQueryDelete(data) {
  return request({
    url: "/admin/sysDatasourceQuery/delete",
    method: "post",
    data: qs.stringify(data)
  });
}
export function sysDatasourceQueryUpdate(data) {
  return request({
    url: "/admin/sysDatasourceQuery/update",
    method: "post",
    data: data
  });
}